import {HelpdeskAPI_Admin} from "./HelpdeskAPI_Admin";

export const HelpdeskAPI = {
    Admin: HelpdeskAPI_Admin,
}
